import React, { useContext, useState, useEffect } from "react";
import loadable from '@loadable/component'
import PropTypes from "prop-types";
import { CartContext } from "components/cart";
import useCampaign from "hooks/useCampaign";
import classNames from "lib/classNames";
// import GiftWithPurchaseWidget from "./GiftWithPurchaseWidget";
// import MultiGiftWithPurchaseWidget from "./MultiGiftWithPurchaseWidget";
import { isOCUProduct, getAllOCUProducts } from "./CheckoutButton";
import Axios from "axios";
import { getAddedGifts, getGoal, GetPresentableItemsList } from "../Utils";
const Bundles = loadable(() => import("./Bundles"));
const Announcement = loadable(() => import("./announcement"));
const GiftWithPurchaseWidget = loadable(() => import("./GiftWithPurchaseWidget"));
const MultiGiftWithPurchaseWidget = loadable(() => import("./MultiGiftWithPurchaseWidget"));

const DefaultAutoDiscountSettings = {
  text: {
    color: {
      a: 1,
      r: 0,
      g: 45,
      b: 255
    },
    font_weight: 400,
    font_size: 0.9,
    text: "{{title}}"
  },
  background: {
    a: 1,
    r: 240,
    g: 242,
    b: 255
  },
  border: {
    a: 1,
    r: 161,
    g: 178,
    b: 255
  },
}

const CartItemsList = (props) => {
  const {
    campaigns,
    shopify_cart_items,
    cart_settings,
    cart_settings: {
      announcement = {}
    },
    productAddedToCart,
    discountCode,
    setCartItems,
    Utils,
    get_total
  } = useContext(CartContext);
  const [one_check_up_sell_product_id, ocu_campaign] = useCampaign(
    "one_check_up_sell", null, true
  )(campaigns, shopify_cart_items);
  const ocu_products = getAllOCUProducts(ocu_campaign)
  const filteredItems = shopify_cart_items.filter((item) => {
    const ocu_product = ocu_products.find(({ product }) => item.product_id.toString() === product?.id)
    return ocu_product ? ocu_product.include_in_atu : !["free_gift", "singleton_gift"].includes(item?.product_type?.toLowerCase())
  })
  const [add_to_unlock_product_id, add_to_unlock, isGlobal] = useCampaign("add_to_unlock")(campaigns, shopify_cart_items);
  const { original, subtotal } = get_total(null, filteredItems);
  const byQuantity = add_to_unlock?.multi_goal_type === "quantity"
  const bundlesDiscounts = Utils.getDiscount({ campaigns, items: shopify_cart_items, getBundlesOnly: true });
  const goalValue = (goal) => byQuantity ? goal : parseInt(goal * 100 * parseFloat(window.Shopify.currency.rate));
  const totalItems = shopify_cart_items.filter(({ price }) => Number(price) > 0).reduce((acc, cur) => acc + cur.quantity, 0);
  const getTotal = (reward_type) => {
    const total = byQuantity
      ? totalItems
      : reward_type === "free_shipping"
        ? subtotal
        : original - bundlesDiscounts;
    return total
  }
  const giftGoals = add_to_unlock?.goals?.filter(({ reward_type, gift }) => reward_type === "gift" && (gift?.product?.title || gift?.products?.length))
  const CAN_RENDER_GIFT_WIDGET = !discountCode &&
    add_to_unlock?.isActive &&
    giftGoals.length &&
    productAddedToCart({ id: add_to_unlock_product_id })
    || (isGlobal && shopify_cart_items.length);
  useEffect(() => {
    async function handleGiftCampaignChange () {
      const gifts = shopify_cart_items.filter(({ product_type }) => ["free_gift", "singleton_gift"].includes(product_type?.toLowerCase()))
      const { origin } = window.location;
      gifts.forEach(async (gift) => {
        const belongsToCurrentATU = !!giftGoals?.find(goal => {
          if (goal.gift.products) {
            return !!goal.gift.products?.find(product => product?.id === gift.product_id.toString())
          }
          return goal.gift.product?.id === gift.product_id.toString()
        })
        if (!belongsToCurrentATU) {
          const { data } = await Axios.post(Utils.getLangPath('cart/update.js'), { updates: { [gift.id]: 0 } })
          if (data?.items) {
            setCartItems(data.items)
          }
        }
      })
    }
    handleGiftCampaignChange()
  }, [shopify_cart_items])
  return (
    <div
      className={classNames("flex flex-col px-5 pt-4", {
        "flex-1": cart_settings.product.grow
      })}
    >
      {!!shopify_cart_items.length && announcement?.isActive && announcement.position === "above_products" && (
        <Announcement announcement={announcement} />
      )}
      {!!shopify_cart_items.length &&
        GetPresentableItemsList(shopify_cart_items)
          .map((cartItem, key) => (
            <CartItem
              cartItem={cartItem}
              key={key}
              giftGoals={giftGoals}
              line={shopify_cart_items.length - key}
            />
          ))}
      {!!CAN_RENDER_GIFT_WIDGET && giftGoals.map((goal, key) => {
        if (!goal.gift?.widget?.active) {
          return null;
        }
        const { products, previous_gift } = goal.gift
        const hasManyGifts = products?.length
        // find if there is a previous goal and inject it on MultiGiftWithPurchaseWidget if the current goal removes the previous one
        const previous_goal = previous_gift === "remove" && key > 0 && giftGoals[key - 1]
        // find the next goal and check if it's unlocked and it's removed previous and a gift is added
        //TODO: find all next goals with  previous_gift = remove
        //TODO: check if at least one goal is unlocked to hide this goal
        const next_goal = key < giftGoals.length - 1 ? giftGoals[key + 1] : undefined
        const next_remove_previous_goals = giftGoals.slice(key + 1).filter(({ gift }) => gift?.previous_gift === "remove")
        const oneGoalIsUnlocked = goalObject => {
          const { goal: oldGoal, specific_goals, reward_type } = goalObject;
          const goal = getGoal({ byQuantity, oldGoal, specific_goals, inCents: true })
          const total = getTotal(reward_type)
          return total >= goal;
        }
        if (next_remove_previous_goals.some(oneGoalIsUnlocked)) {
          return null;
        }
        if (hasManyGifts)
          return <MultiGiftWithPurchaseWidget key={key} previous_goal={previous_goal} giftGoal={goal} filteredItems={filteredItems} add_to_unlock={add_to_unlock} />
        return <GiftWithPurchaseWidget key={key} byQuantity={byQuantity} giftGoal={goal} filteredItems={filteredItems} multi_goal_type={add_to_unlock.multi_goal_type} />
      })}
      {!!shopify_cart_items.length && announcement?.isActive && announcement.position === "bellow_products" && (
        <Announcement announcement={announcement} />
      )}
    </div>
  );
};

CartItemsList.propTypes = {};

const CartItem = ({ cartItem, giftGoals }) => {
  const {
    id,
    image,
    product_title,
    product_type,
    quantity,
    line,
    line_quantity,
    price,
    product_id,
    variant_id,
    url,
    itemSoldOut,
    variant_title,
    selling_plan_allocation,
    properties
  } = cartItem;
  const [error, setError] = useState(null);
  const [soldOut, setSoldOut] = useState(!!itemSoldOut);
  const [maxQuantity, setMaxQuantity] = useState(Infinity);
  const {
    campaigns,
    update_cart_item,
    Utils,
    isPreview,
    cart_settings: {
      theme: { background },
      product,
      money_format,
      rtl,
      auto_discount = DefaultAutoDiscountSettings
    },
    shopify_cart_items,
    productAddedToCart,
    discountCode,
    removeFBTUpsell,
    compareAtMap,
    hasAutoDiscount
  } = useContext(CartContext);
  const [one_check_up_sell_product_id, ocu_campaign] = useCampaign(
    "one_check_up_sell", null, true
  )(campaigns, shopify_cart_items);
  const [_, bundles] = useCampaign("bundles", product_id)(
    campaigns,
    shopify_cart_items
  );
  const IS_EXAMPLE = isPreview && product_id < 10;
  const IS_ONE_CHECK_PRODUCT =
    shopify_cart_items.length > 1 &&
    productAddedToCart(one_check_up_sell_product_id) &&
    isOCUProduct(ocu_campaign, product_id, IS_EXAMPLE)
  const IS_GIFT_PRODUCT = !!giftGoals?.find(({ gift }) => gift?.product?.variant_id === variant_id?.toString())
  const updateItem = (step) => {
    const newQuantity = (line_quantity || quantity) + step;
    update_cart_item({ line, variant_id: id, quantity: newQuantity });
    if (newQuantity === 0) removeFBTUpsell(id);
  };
  const formatText = (text) => {
    const { price, original } = getPrice();
    return text
      .replace("{{product_title}}", product_title)
      .replace("{{product_price}}", Utils.formatMoney(price, money_format))
      .replace(
        "{{original_price}}",
        original
          ? `<del class='mu-opacity-75 ${rtl ? "mu-ml-1" : "mu-mr-1"
          }' style='font-size:0.8em'>${Utils.formatMoney(
            original,
            money_format
          )}</del> `
          : ""
      );
  };
  const hasCompareAt = (variant_id, quantity, price = null) => {
    const finalPrice = compareAtMap && compareAtMap[variant_id] ? compareAtMap[variant_id] : price
    // const finalPrice = compareAtMap && compareAtMap[variant_id] ? compareAtMap[variant_id] * parseFloat(window.Shopify.currency.rate) : price
    return finalPrice * quantity * parseFloat(window.Shopify.currency.rate)
  }
  const autoDiscount = Utils.GetCartItemAutoDiscount(cartItem)
  const getPrice = () => {
    let single_price = window.mu_show_single_price;
    if (autoDiscount) {
      const { discounted_price } = cartItem
      return { price: discounted_price * (single_price ? 1 : quantity), original: hasCompareAt(id, (single_price ? 1 : quantity)) };
    }
    if (!bundles) {
      return { price: price * (single_price ? 1 : quantity), original: hasCompareAt(id, (single_price ? 1 : quantity)) };
    }
    const selectedBundle =
      bundles.list.find(
        (bundle) => bundle.quantity === (single_price ? 1 : quantity)
      ) ||
      Utils.sortByQuantity(bundles.list).find(
        (bundle) => bundle.quantity < (single_price ? 1 : quantity)
      );
    if (!selectedBundle) return { price: price * (single_price ? 1 : quantity), original: hasCompareAt(id, (single_price ? 1 : quantity)) };
    const discountedPrice = Utils.getBundleDiscount(
      selectedBundle,
      (single_price ? 1 : quantity),
      price,
      money_format
    );
    return { price: discountedPrice.plain, original: hasCompareAt(id, (single_price ? 1 : quantity), price) };
  };

  function formatAutoDiscount (discount) {
    const { title, amount } = discount
    return auto_discount.text.text.replace('{{title}}', title).replace('{{amount}}', Utils.formatMoney(amount, money_format))
  }

  if (["free_gift", "singleton_gift"].includes(product_type?.toLowerCase())) {
    return null;
  }
  return IS_ONE_CHECK_PRODUCT || IS_GIFT_PRODUCT ? null : (
    <div className={classNames("mb-6 cart-item")}>
      <div className={classNames("flex")}>
        <div
          className={classNames("bg-cover bg-center block", {
            "ml-2": rtl,
            "mr-2": !rtl,
          })}
          style={{
            backgroundImage: `url(${image})`,
            width: `${product.image_size}px`,
            height: `${product.image_size}px`,
          }}
        />
        <div className={classNames("flex-1 flex-col")}>
          <div
            className={classNames("mb-2 overflow-hidden font-bold line-clamp")}
            style={{
              fontSize: Utils.em(product.title.font_size),
              color: Utils.formatColor(product.title.color),
              fontWeight: product.title.font_weight,
            }}
          >
            {isPreview ? (
              <span
                dangerouslySetInnerHTML={{
                  __html: formatText(product.title.text),
                }}
              />
            ) : (
              <a
                href={`${window.origin}${url}`}
                dangerouslySetInnerHTML={{
                  __html: formatText(product.title.text),
                }}
              />
            )}
          </div>
          {variant_title && !window.hide_variant_title && (
            <p>{variant_title.replace("/", "•")}</p>
          )}
          {!!autoDiscount && (
            <div
              className={classNames(
                "text-sm p-1 rounded mb-1 flex items-center space-x-1"
              )}
              style={{
                fontSize: `${auto_discount.text.font_size}em`,
                fontWeight: auto_discount.text.font_weight,
                color: Utils.formatColor(auto_discount.text.color),
                background: Utils.formatColor(auto_discount.background),
                border: `${Utils.formatColor(auto_discount.border)} 1px solid`,
              }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20 20"
                fill="currentColor"
                className={classNames("w-5 h-5")}
              >
                <path
                  fill-rule="evenodd"
                  d="M5.5 3A2.5 2.5 0 003 5.5v2.879a2.5 2.5 0 00.732 1.767l6.5 6.5a2.5 2.5 0 003.536 0l2.878-2.878a2.5 2.5 0 000-3.536l-6.5-6.5A2.5 2.5 0 008.38 3H5.5zM6 7a1 1 0 100-2 1 1 0 000 2z"
                  clip-rule="evenodd"
                />
              </svg>
              <span className={classNames("leading-none")}>
                {formatAutoDiscount(cartItem.discounts[0])}
              </span>
            </div>
          )}
          {properties && window.show_item_properties && (
            <div className={classNames("mb-2 space-y-1")}>
              {Object.entries(properties)
                .filter(([key, value]) => typeof value === "string")
                .map(([key, value]) => (
                  <p
                    className={classNames("text-xs capitalize")}
                    key={key}
                    style={{ opacity: 0.8 }}
                  >
                    <b className={classNames("font-bold")}>{`${key}: `}</b>
                    {value}
                  </p>
                ))}
            </div>
          )}
          {selling_plan_allocation?.selling_plan && (
            <p className={classNames("text-xs")}>
              {selling_plan_allocation?.selling_plan?.name}
            </p>
          )}
          {properties &&
            properties["File1"] &&
            Object.entries(properties).map(([name, url]) => (
              <div
                key={name}
                id="mu-gf-file"
                className={classNames("flex items-center justify-start my-2")}
              >
                <a href={url} target={"_blank"}>
                  <p className={classNames("text-2xl")}>{name}</p>
                </a>
                <a href={url} target={"_blank"}>
                  <img
                    className={classNames(
                      "rounded-sm ml-12 h-12 w-12 object-cover"
                    )}
                    src={url}
                  />
                </a>
              </div>
            ))}
          {properties && properties["_pplr_preview"] && (
            <div className={classNames("mt-1 mb-2")}>
              {Object.entries(properties)
                .filter(
                  ([name, value]) =>
                    name &&
                    value &&
                    !name.includes("_pplr_preview") &&
                    !name.includes("_svg")
                )
                .map(([name, value]) => (
                  <div
                    key={name}
                    className={classNames("text-xs")}
                    dangerouslySetInnerHTML={{
                      __html: `${name.replace(
                        "See photo guide",
                        ""
                      )}: ${value}`,
                    }}
                  ></div>
                ))}
            </div>
          )}

          {/* {window?.mu_form_files &&
          window?.mu_form_files[id] &&
          window.mu_form_files[id].map(
            (name) =>
              properties && properties[name] && (
                <div className={classNames("my-2")} key={name}>
                  <p className={classNames("mb-1 capitalize")}>{name}</p>
                  <div
                    className={classNames(
                      "w-8 h-8 rounded-sm bg-center bg-cover"
                    )}
                    style={{ backgroundImage: `url(${properties[name]})` }}
                  />
                </div>
              )
          )} */}
          <div className={classNames("flex items-center")}>
            <b
              className={classNames("flex-1")}
              style={{
                fontSize: Utils.em(product.price.font_size),
                fontWeight: product.price.font_weight,
                color: Utils.formatColor(product.price.color),
              }}
              dangerouslySetInnerHTML={{
                __html: formatText(product.price.text),
              }}
            />

            {!soldOut && (
              <div className={classNames("flex items-stretch")}>
                <button
                  style={{
                    border: "1px solid",
                    color: Utils.formatColor(product.title.color),
                    borderColor: Utils.lighterColor(0.8, product.title.color),
                    minWidth: "unset",
                  }}
                  className={classNames(
                    "border flex-center p-1 xs:p-2 bg-transparent",
                    {
                      "rounded-r rounded-l-none": rtl,
                      "rounded-l rounded-r-none": !rtl,
                    }
                  )}
                  onClick={() => updateItem(-1)}
                  ariaLabel={
                    quantity === 1
                      ? "remove item from cart"
                      : "decrease item quantity by one"
                  }
                >
                  {quantity === 1 && (
                    <svg
                      aria-hidden="true"
                      focusable="false"
                      data-icon="trash"
                      style={{ height: 12 }}
                      role="img"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 448 512"
                    >
                      <path
                        fill="currentColor"
                        d="M0 84V56c0-13.3 10.7-24 24-24h112l9.4-18.7c4-8.2 12.3-13.3 21.4-13.3h114.3c9.1 0 17.4 5.1 21.5 13.3L312 32h112c13.3 0 24 10.7 24 24v28c0 6.6-5.4 12-12 12H12C5.4 96 0 90.6 0 84zm415.2 56.7L394.8 467c-1.6 25.3-22.6 45-47.9 45H101.1c-25.3 0-46.3-19.7-47.9-45L32.8 140.7c-.4-6.9 5.1-12.7 12-12.7h358.5c6.8 0 12.3 5.8 11.9 12.7z"
                      ></path>
                    </svg>
                  )}
                  {quantity > 1 && (
                    <svg
                      aria-hidden="true"
                      focusable="false"
                      data-icon="minus"
                      style={{ height: 12 }}
                      role="img"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 448 512"
                    >
                      <path
                        fill="currentColor"
                        d="M424 318.2c13.3 0 24-10.7 24-24v-76.4c0-13.3-10.7-24-24-24H24c-13.3 0-24 10.7-24 24v76.4c0 13.3 10.7 24 24 24h400z"
                      ></path>
                    </svg>
                  )}
                </button>
                <div
                  className={classNames(
                    "px-2 border-t border-b font-bold flex-center w-8"
                  )}
                  style={{
                    color: Utils.formatColor(product.title.color),
                    borderColor: Utils.lighterColor(0.8, product.title.color),
                  }}
                >
                  {quantity}
                </div>
                <button
                  style={{
                    border: "1px solid",
                    color: Utils.formatColor(product.title.color),
                    borderColor: Utils.lighterColor(0.8, product.title.color),
                    minWidth: "unset",
                  }}
                  className={classNames(
                    "border flex-center p-1 xs:p-2 bg-transparent",
                    {
                      "rounded-l rounded-r-none": rtl,
                      "rounded-r rounded-l-none": !rtl,
                      "opacity-50 cursor-not-allowed":
                        quantity + 1 > maxQuantity,
                    }
                  )}
                  disabled={quantity + 1 > maxQuantity}
                  ariaLabel="increase item quantity by one"
                  onClick={() => updateItem(+1)}
                >
                  <svg
                    aria-hidden="true"
                    focusable="false"
                    data-icon="plus"
                    style={{ height: 12 }}
                    role="img"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 448 512"
                  >
                    <path
                      fill="currentColor"
                      d="M448 294.2v-76.4c0-13.3-10.7-24-24-24H286.2V56c0-13.3-10.7-24-24-24h-76.4c-13.3 0-24 10.7-24 24v137.8H24c-13.3 0-24 10.7-24 24v76.4c0 13.3 10.7 24 24 24h137.8V456c0 13.3 10.7 24 24 24h76.4c13.3 0 24-10.7 24-24V318.2H424c13.3 0 24-10.7 24-24z"
                    ></path>
                  </svg>
                </button>
              </div>
            )}
            {soldOut && (
              <div className={classNames("flex text-red-500 items-center")}>
                <svg
                  aria-hidden="true"
                  focusable="false"
                  data-icon="ban"
                  role="img"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 512 512"
                  className={classNames("w-4 h-4", rtl ? "ml-1" : "mr-1")}
                >
                  <path
                    fill="currentColor"
                    d="M256 8C119.034 8 8 119.033 8 256s111.034 248 248 248 248-111.034 248-248S392.967 8 256 8zm130.108 117.892c65.448 65.448 70 165.481 20.677 235.637L150.47 105.216c70.204-49.356 170.226-44.735 235.638 20.676zM125.892 386.108c-65.448-65.448-70-165.481-20.677-235.637L361.53 406.784c-70.203 49.356-170.226 44.736-235.638-20.676z"
                  ></path>
                </svg>
                <span>Sold out</span>
              </div>
            )}
          </div>
        </div>
      </div>
      {!!bundles && !soldOut && !discountCode && !hasAutoDiscount && (
        <Bundles
          id={id}
          line={line}
          bundles={bundles}
          soldOut={{
            get: soldOut,
            set: (v) => setSoldOut(v),
          }}
          maxQuantity={{
            get: maxQuantity,
            set: (v) => setMaxQuantity(v),
          }}
          itemQuantity={quantity}
        />
      )}
    </div>
  );
};

export default CartItemsList;
